import { useReducer, useCallback } from "react";

import { RecoverForm, useRecoverState } from "../interfaces/auth";

import { onRecover } from "../services/auth";

const initialState = {
  loading: false,
  error: false,
  success: false,
} as useRecoverState;

interface Action {
  type: "loading" | "error" | "success";
  value?: any;
}

const reducer = (state: useRecoverState, action: Action) => {
  switch (action.type) {
    case "loading":
      return {
        ...state,
        loading: action.value,
      };
    case "success":
      return {
        ...state,
        success: action.value,
      };
    case "error":
      return {
        ...state,
        error: action.value,
      };
    default:
      return state;
  }
};

export const useRecover = (fields: RecoverForm) => {
  const [{ loading, error, success }, dispatch] = useReducer(
    reducer,
    initialState
  );
  const onSubmit = useCallback(
    (event: any) => {
      dispatch({ type: "loading", value: true });
      if (event) {
        event.preventDefault();
      }
      onRecover(fields)
        .then((res) => {
          dispatch({ type: "success", value: true });
          dispatch({ type: "loading", value: false });
          dispatch({ type: "error", value: false });
        })
        .catch((err) => {
          dispatch({ type: "error", value: true });
          dispatch({ type: "loading", value: false });
        });
    },
    [fields]
  );

  return {
    loading,
    error,
    success,
    onSubmit,
    cancelError: () => dispatch({ type: "error", value: false }),
  };
};
